module.exports = __webpack_public_path__ + "static/img/hot-Grade3.53f10390.png";